import React, { Component} from 'react';
import $ from 'jquery';

import  AccordionGroup  from '../partials/accordion/AccordionGroup.js';

import {MOBILE_STORES} from '../../app/common/mobile-stores.js';
import {questions} from '../../app/common/faq-questions';

class Faq extends Component {

    constructor(props) {
        super(props);

        this.state = {
            opened  : false,
            key     : null 
        }
    }

    componentDidMount() {
        $('.close').on('click', function () {
            $('body').removeClass('scroll-off');
          });
    }

    onToggle = (opened, key) => {
        this.setState({ 
            opened  : !opened,
            key     : key 
        });
    }

    updateAccordionGroups = () => {
        return questions.map((question, index) => {
            const openedState = (this.state.key === index) ? this.state.opened : false;

            return( 
             <AccordionGroup question={question.label} opened={openedState} toggle={this.onToggle} key={index} keyIndex={index}>
                 <p dangerouslySetInnerHTML={{__html: question.answer}}></p>
             </AccordionGroup>
            )
         });
    }

    render() {
        return(
        <div>
            <section className="page-faq">
                <div className="container-main">
                    <div className="wrapper">
                        <h1>
                            <span>Често задавани въпроси</span>
                        </h1>
                        <div className="faq-list">
                            {this.updateAccordionGroups()}     
                        </div>
                    </div>
                </div>
            </section>

            <section className="app-download">
                <div className="container-main">
                    <h1>Свали<br />приложението от</h1>
                    <ul className="download-buttons">
                        <li>
                            <figure className="google-play">
                                <a href={MOBILE_STORES.playStoreUrl} title="Свали от Google Play">
                                    <img src="assets/img/download-google-play.png" alt="Nu INS app in Google Play"></img>
                                </a>
                            </figure>
                        </li>
                        <li>
                            <figure className="app-store">
                                <a href={MOBILE_STORES.appStoreUrl} title="Свали от App Store">
                                    <img src="assets/img/download-app-store.png" alt="Nu INS app in App Store"></img>
                                </a>
                            </figure>
                        </li>
                        <li>
                            <figure className="app-gallery">
                                <a href={MOBILE_STORES.appGalleryUrl} title="Свали от App Gallery">
                                    <img src="assets/img/download-huawei.png" alt="Nu INS app in App Gallery"></img>
                                </a>
                            </figure>
                        </li>
                    </ul>
                </div>
            </section>
        </div>  
        );
    }
};

export default Faq;